import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../axiosConfig';
import { useAuth } from '../../context/AuthContext';



const ProjectDetail = () => {
  const { id } = useParams(); // 获取动态路由参数
  const [project, setProject] = useState(null);
  const { user } = useAuth();
  console.log("user", user);



  useEffect(() => {
    axios.get(`/jianshenxiangmu/detail/${id}`) // 根据项目 ID 获取详情
      .then(response => { 
        console.log("detail response", response);
        console.log("id response", typeof(id));

        return setProject(response.data.data)})
      .catch(error => console.error('Error fetching project detail:', error));
  }, [id]);

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      project {id}
      <h1>{project.xiangmumingcheng}</h1>
      <p>{project.xiangmuleixing}</p>
    </div>
  );
};

export default ProjectDetail;
